"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ceranesi": {
    "8157ab70": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "skipSearch": false
    }],
    "ceranesi-gaiazza": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c01f8868": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "skipSearch": false
    }],
    "geo": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0be9392b": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "skipSearch": false
    }],
    "livellato": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12197932": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-di-paravanico": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39462451": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "skipSearch": false
    }],
    "torbi": [{
      "hkey": "a9520f55",
      "slug": "ceranesi",
      "name": "Ceranesi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;